<template>
  <div class="DialogReportHistory__Component">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">רשימת ספקים לעירייה {{ municipality.Municipality }}</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <div class="history-container" v-if="providers.length">
          <table class="table">
            <thead>
              <tr>
                <th>
                  מזהה
                </th>
                <th>
                  האם קיים בAPI
                </th>
                <th>
                  מתאריך
                </th>
                <th>
                  עד תאריך
                </th>
                <th>
                  סקראפר
                </th>
                <th>
                  מזהה עיר לסקראפר
                </th>
                <th>
                  ספק תשלום
                </th>
                <th>
                  מזהה עיר לספק תשלום
                </th>
                <th>
                  מזהה עיר לתשלום
                </th>
                <th>
                  קישור לתשלום
                </th>
              </tr>
            </thead>
            <tr v-for="(provider, index) in providers" :key="index">
              <td>{{ provider.Id }}</td>
              <td>{{ provider.IsInApi ? 'כן' : 'לא' }}</td>
              <td>{{ provider.FromDate ? parseDate(provider.FromDate) : '' }}</td>
              <td>{{ provider.ToDate ? parseDate(provider.ToDate) : '' }}</td>
              <td>{{ provider.Scraper ? provider.Scraper.Name : '' }}</td>
              <td>{{ provider.ScraperCityId }}</td>
              <td>{{ provider.PaymentProvider ? provider.PaymentProvider.Name: '' }}</td>
              <td>{{ provider.PaymentProviderCityId }}</td>
              <td>{{ provider.PaymentUrlCityId }}</td>
              <td><a style="text-decoration: underline;" target="_blank" :href="provider.PaymentUrlBase">קישור</a></td>
            </tr>
          </table>
        </div>
        <h1 v-if="!providers.length">אין ספקים</h1>
      </section>
      <footer class="modal-card-foot">
        <b-button label="סגור" @click="$emit('close')" />
      </footer>
    </div>
  </div>
</template>

<script>
import MunicipalitiesService from '@/services/MunicipalitiesService';
import moment from 'moment';

export default {
  name: "DialogReportHistory",
  props: ["municipality"],
  data() {
    return {
      providers: []
    };
  },
  created() {
    this.getProviders();
  },
  methods: {
    getProviders() {
      MunicipalitiesService.getMunicipality(this.municipality.Id).then((r) => {
        this.providers = r.data.Providers;
      });
    },
    parseDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
  }
};
</script>

<style lang="scss" scoped>
.DialogReportHistory__Component {
  ::v-deep .modal-card {
    width: 100% !important;
    height: 1200px;
  }

  ::v-deep .modal-card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

.history-container {
  height: 100%;
  overflow: auto;
}

::v-deep .pagination {
  justify-content: center;
  direction: ltr;
  margin: 0;

  .pagination-list {
    flex-grow: unset;
  }
}
</style>;
